<style>
.vs-card--content {
    margin-bottom: 0;
}
.field-label {
    font-weight: 600;
    color: #444;
    font-size: 13px;
}
.field-value {
    font-size: 13px;
    color: #222;
}
.section-title {
    font-size: 15px;
    font-weight: 700;
    color: #333;
    margin-bottom: 12px;
    padding-bottom: 6px;
    border-bottom: 2px solid #e8e8e8;
}
.status-badge {
    display: inline-block;
    padding: 4px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.3px;
}
.lampiran-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 10px;
    background: #f8f9fa;
    border-radius: 6px;
    margin-bottom: 6px;
    font-size: 13px;
}
.lampiran-icon {
    font-size: 18px;
    color: #6c757d;
}
.lampiran-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
}
.lampiran-row .file-label {
    font-size: 12px;
    color: #28a745;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.milestone-timeline {
    position: relative;
    padding: 8px 0 4px;
}
.milestone-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    position: relative;
    padding-bottom: 28px;
}
.milestone-item:last-child {
    padding-bottom: 0;
}
.milestone-item:not(:last-child)::before {
    content: '';
    position: absolute;
    left: 15px;
    top: 32px;
    bottom: 0;
    width: 2px;
    background: linear-gradient(to bottom, #d1d5db, #f3f4f6);
}
.milestone-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;
    z-index: 1;
    box-shadow: 0 0 0 4px #fff, 0 0 0 5px #e5e7eb;
}
.milestone-icon--approve {
    background: #16a34a;
    color: #fff;
}
.milestone-icon--reject {
    background: #dc2626;
    color: #fff;
}
.milestone-content {
    flex: 1;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 12px 16px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
    margin-top: -2px;
}
.milestone-content--approve {
    border-left: 3px solid #16a34a;
}
.milestone-content--reject {
    border-left: 3px solid #dc2626;
}
.milestone-step-label {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #9ca3af;
    margin-bottom: 3px;
}
.milestone-approver-name {
    font-weight: 700;
    font-size: 13px;
    color: #111827;
}
.milestone-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 6px;
}
.milestone-date {
    font-size: 11px;
    color: #9ca3af;
    display: inline-flex;
    align-items: center;
    gap: 3px;
}
.milestone-note {
    font-size: 12px;
    color: #6b7280;
    font-style: italic;
    margin-top: 8px;
    padding: 6px 10px;
    background: #f9fafb;
    border-radius: 6px;
    border-left: 2px solid #d1d5db;
    line-height: 1.5;
}
.detail-table-wrap {
    overflow-x: auto;
}
.detail-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}
.detail-table th {
    background: #f3f4f6;
    color: #374151;
    font-weight: 700;
    padding: 10px 12px;
    text-align: left;
    white-space: nowrap;
    border-bottom: 2px solid #e5e7eb;
}
.detail-table td {
    padding: 9px 12px;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
}
.product-row td {
    background: #fff;
    font-weight: 600;
}
.product-row:hover td {
    background: #f9fafb;
}
.sub-row td {
    background: #f5f7ff;
    font-size: 12px;
    color: #555;
    border-bottom: 1px solid #eef0f8;
}
.sub-row:hover td {
    background: #eef2ff;
}
.detail-total-row td {
    background: #eef2ff;
    font-weight: 700;
    color: #3730a3;
    font-size: 13px;
    border-top: 2px solid #c7d2fe;
}
.expand-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 4px;
    display: inline-flex;
    align-items: center;
    color: #6b7280;
    border-radius: 4px;
    vertical-align: middle;
}
.expand-btn:hover {
    background: #e5e7eb;
    color: #111827;
}
.harga-jual-input {
    width: 140px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 5px 8px;
    font-size: 12px;
    color: #111827;
    background: #f0fdf4;
    outline: none;
    transition: border-color 0.15s, box-shadow 0.15s;
}
.harga-jual-input:focus {
    border-color: #16a34a;
    background: #fff;
    box-shadow: 0 0 0 2px rgba(22,163,74,0.15);
}
.harga-jual-input.sub-input {
    width: 120px;
    background: #f9fafb;
}
.biaya-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}
.biaya-table th {
    background: #fef3c7;
    color: #92400e;
    font-weight: 700;
    padding: 9px 14px;
    text-align: left;
    border-bottom: 2px solid #fde68a;
    white-space: nowrap;
}
.biaya-table td {
    padding: 10px 14px;
    border-bottom: 1px solid #fef9ec;
    vertical-align: middle;
}
.biaya-nama {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: #374151;
}
.biaya-nama-icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.biaya-input {
    width: 160px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 5px 9px;
    font-size: 12px;
    color: #111827;
    background: #fffbeb;
    outline: none;
    transition: border-color 0.15s, box-shadow 0.15s;
}
.biaya-input:focus {
    border-color: #f59e0b;
    background: #fff;
    box-shadow: 0 0 0 2px rgba(245,158,11,0.15);
}
.biaya-pct-badge {
    display: inline-block;
    background: #fef3c7;
    color: #92400e;
    border-radius: 20px;
    padding: 3px 12px;
    font-size: 12px;
    font-weight: 700;
    min-width: 64px;
    text-align: center;
}
.biaya-total-row td {
    background: #fef3c7;
    font-weight: 700;
    color: #92400e;
    border-top: 2px solid #fde68a;
    font-size: 13px;
}
.approval-form-box {
    background: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    padding: 20px 24px;
    margin-top: 8px;
}
.nego-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 14px;
}
.nego-row.self {
    flex-direction: row-reverse;
}
.nego-avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: white;
    flex-shrink: 0;
}
.nego-bubble {
    background: #f0f4ff;
    border: 1px solid #c7d2fe;
    border-radius: 0 10px 10px 10px;
    padding: 10px 14px;
    font-size: 13px;
    flex: 1;
}
.nego-bubble.self {
    background: #f0fdf4;
    border-color: #bbf7d0;
    border-radius: 10px 0 10px 10px;
}
.nego-form-box {
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 10px;
    padding: 16px 20px;
    margin-top: 12px;
}
</style>

<template>
    <div>
        <div class="w-full vx-col mb-base">
            <vs-card class="p-4 mb-6">

                <!-- ===== HEADER CARD ===== -->
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <div style="margin-left: 12px">
                            <h4 style="margin:0">SP PMT DOI</h4>
                            <span style="font-size:12px;color:#888">{{ data.nomor_pesanan }}</span>
                        </div>
                    </div>
                    <span class="status-badge" :style="statusStyle(data.status)">
                        {{ statusLabel(data.status) }}
                    </span>
                </div>

                <!-- ===== SECTION 1: INFO PESANAN ===== -->
                <div class="mt-6">
                    <p class="section-title">Informasi Pesanan</p>
                    <div class="vx-row">
                        <div class="w-full vx-col lg:w-1/2">
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Obyek</div>
                                <div class="w-2/3 vx-col field-value">{{ data.obyek }}</div>
                            </div>
                            <div class="hidden mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Ekspektasi Selesai</div>
                                <div class="w-2/3 vx-col field-value">{{ data.ekspektasi_selesai || '-' }}</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Selesai Paling Lambat</div>
                                <div class="w-2/3 vx-col field-value">{{ data.selesai_paling_lambat }}</div>
                            </div>
                        </div>
                        <div class="w-full vx-col lg:w-1/2">
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">PKS</div>
                                <div class="w-2/3 vx-col field-value">{{ data.pks }}</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Tanggal Pesan</div>
                                <div class="w-2/3 vx-col field-value">{{ data.tanggal_pesan }}</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Nama Regional Head</div>
                                <div class="w-2/3 vx-col field-value">{{ data.nama_regional_head }}</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Email Regional Head</div>
                                <div class="w-2/3 vx-col field-value">{{ data.email_regional_head }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ===== SECTION 2: DETIL PESANAN ===== -->
                <div class="mt-6">
                    <p class="section-title">Detil Pesanan</p>
                    <div class="detail-table-wrap">
                        <table class="detail-table">
                            <thead>
                                <tr>
                                    <th style="width:40px">No</th>
                                    <th style="width:36px"></th>
                                    <th style="min-width:200px">Nama Produk / Material</th>
                                    <th style="min-width:180px">Keterangan</th>
                                    <th style="min-width:90px">Jumlah</th>
                                    <th style="min-width:80px">Satuan</th>
                                    <th style="min-width:140px">Harga Standar</th>
                                    <th style="min-width:150px">Harga Pengajuan</th>
                                    <th style="min-width:160px">Harga Jual</th>
                                </tr>
                            </thead>
                            <tbody
                                v-for="(d, i) in data.details"
                                :key="'detail-'+i"
                            >
                                <!-- Baris produk -->
                                <tr class="product-row">
                                    <td>{{ i + 1 }}</td>
                                    <td>
                                        <button class="expand-btn" @click="toggleRow(i)" :title="expandedRows[i] ? 'Sembunyikan material' : 'Lihat material'">
                                            <span class="material-icons" style="font-size:18px">{{ expandedRows[i] ? 'expand_less' : 'expand_more' }}</span>
                                        </button>
                                    </td>
                                    <td>{{ d.product_name }}</td>
                                    <td>{{ d.keterangan }}</td>
                                    <td>{{ d.jumlah }}</td>
                                    <td>{{ d.satuan }}</td>
                                    <td>{{ formatRupiah(d.harga_pmt) }}</td>
                                    <td>{{ formatRupiah(d.harga_diinginkan) }}</td>
                                    <td>
                                        <input
                                            class="harga-jual-input"
                                            type="number"
                                            v-model.number="d.harga_jual"
                                            min="0"
                                        />
                                    </td>
                                </tr>
                                <!-- Baris sub-material -->
                                <template v-if="expandedRows[i]">
                                <tr
                                    v-for="(m, mi) in d.sub_materials"
                                    :key="'sub-'+mi"
                                    class="sub-row"
                                >
                                    <td></td>
                                    <td style="text-align:center;color:#c7d2fe">
                                        <span class="material-icons" style="font-size:14px;vertical-align:middle">subdirectory_arrow_right</span>
                                    </td>
                                    <td style="padding-left:8px;color:#4338ca">{{ m.nama }}</td>
                                    <td>{{ m.keterangan }}</td>
                                    <td>{{ m.jumlah }}</td>
                                    <td>{{ m.satuan }}</td>
                                    <td>{{ formatRupiah(m.harga_pmt) }}</td>
                                    <td>{{ formatRupiah(m.harga_diinginkan) }}</td>
                                    <td>
                                        <input
                                            class="harga-jual-input sub-input"
                                            type="number"
                                            v-model.number="m.harga_jual"
                                            min="0"
                                        />
                                    </td>
                                </tr>
                                </template>
                            </tbody>
                            <tfoot>
                                <tr class="detail-total-row">
                                    <td colspan="4" style="text-align:right;padding-right:12px">TOTAL</td>
                                    <td>{{ totalJumlah }}</td>
                                    <td></td>
                                    <td>{{ formatRupiah(totalHargaPmt) }}</td>
                                    <td>{{ formatRupiah(totalHargaDiinginkan) }}</td>
                                    <td>{{ formatRupiah(totalHargaJual) }}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>

                <!-- ===== SECTION 2.5: BIAYA TAMBAHAN ===== -->
                <div class="mt-6">
                    <p class="section-title">Biaya Tambahan</p>
                    <table class="biaya-table">
                        <thead>
                            <tr>
                                <th style="min-width:200px">Nama Biaya</th>
                                <th style="min-width:200px">Nilai Biaya</th>
                                <th style="min-width:140px">Persentase dari Total Harga Jual</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(b, bi) in biayaTambahan" :key="'biaya-'+bi">
                                <td>
                                    <span class="biaya-nama">
                                        <span
                                            class="biaya-nama-icon"
                                            :style="b.iconStyle"
                                        >
                                            <span class="material-icons" style="font-size:15px" :style="{ color: b.iconColor }">{{ b.icon }}</span>
                                        </span>
                                        {{ b.nama }}
                                    </span>
                                </td>
                                <td>
                                    <input
                                        class="biaya-input"
                                        type="number"
                                        v-model.number="b.nilai"
                                        min="0"
                                        placeholder="0"
                                    />
                                    <span style="margin-left:6px;font-size:11px;color:#aaa">{{ formatRupiah(b.nilai) }}</span>
                                </td>
                                <td>
                                    <span class="biaya-pct-badge">{{ hitungPersen(b.nilai) }}</span>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="biaya-total-row">
                                <td>Total Biaya Tambahan</td>
                                <td>{{ formatRupiah(totalBiayaTambahan) }}</td>
                                <td>
                                    <span class="biaya-pct-badge" style="background:#f59e0b;color:#fff">{{ hitungPersen(totalBiayaTambahan) }}</span>
                                </td>
                            </tr>
                            
                            <tr class="biaya-total-row">
                                <td>Grand Total</td>
                                <td>1.897.400.000</td>
                                <td>
                                    
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <!-- ===== SECTION 3: LAMPIRAN DOKUMEN ===== -->
                <div class="mt-6">
                    <p class="section-title">Lampiran Dokumen Permohonan</p>
                    <div
                        v-for="(file, fi) in data.lampiran"
                        :key="fi"
                        class="lampiran-item"
                    >
                        <span class="material-icons lampiran-icon">attach_file</span>
                        <span style="width:100px;font-weight:600;color:#555">{{ file.jenis_label }}</span>
                        <span style="flex:1">{{ file.nama }}</span>
                        <span style="flex:1">2026-06-15 Andi L.M.</span>
                        <vs-button
                            size="small"
                            type="border"
                            icon="download"
                            @click="downloadLampiran(file)"
                        >Unduh</vs-button>
                    </div>
                    <p v-if="!data.lampiran || data.lampiran.length === 0" style="color:#aaa;font-size:13px">
                        Tidak ada lampiran
                    </p>



                    
                    <div
                        v-for="(file, fi) in data.lampiran2"
                        :key="fi"
                        class="lampiran-row"
                    >
                        <vs-select
                            v-model="file.jenis"
                            width="160px"
                            class="selectExample"
                        >
                            <vs-select-item
                                v-for="(j, ji) in jenisFile"
                                :key="ji"
                                :value="j.value"
                                :text="j.label"
                            />
                        </vs-select>
                        <input
                            type="file"
                            @change="onFileChange($event, fi)"
                            style="flex: 1; padding: 4px 0; font-size: 13px;"
                        />
                        <span v-if="file.nama" class="file-label">{{ file.nama }}</span>
                        <vs-button
                            color="danger"
                            type="border"
                            icon="delete"
                            size="small"
                            @click="removeLampiran(fi)"
                        ></vs-button>
                    </div>
                    <vs-button type="border" class="mt-2" @click="addLampiran()">
                        + Tambah Lampiran
                    </vs-button>


                    
                </div>

                <!-- ===== SECTION 4: CATATAN ===== -->
                <div class="mt-6">
                    <p class="section-title">Catatan</p>
                    <div
                        style="background:#fffdf0;border:1px solid #e8e0b0;border-radius:6px;padding:12px 16px;font-size:13px;min-height:50px;white-space:pre-line"
                    >{{ data.catatan || '-' }}</div>
                </div>

                <!-- ===== SECTION 5: TEMBUSAN ===== -->
                <div class="mt-6">
                    <p class="section-title">Tembusan</p>
                    <div class="vx-row">
                        <div class="w-full vx-col lg:w-1/2">
                            <p style="font-size:12px;font-weight:600;color:#888;margin-bottom:6px">Jenis Tembusan</p>
                            <div
                                v-for="(t, ti) in data.tembusan2"
                                :key="'t2-'+ti"
                                style="display:inline-block;background:#e9ecef;border-radius:4px;padding:3px 10px;margin:0 4px 4px 0;font-size:12px"
                            >{{ t.label }}</div>
                        </div>
                        <div class="w-full vx-col lg:w-1/2">
                            <p style="font-size:12px;font-weight:600;color:#888;margin-bottom:6px">Dikirimkan Kepada</p>
                            <div
                                v-for="(u, ui) in data.tembusan"
                                :key="'tu-'+ui"
                                style="display:flex;align-items:center;gap:6px;margin-bottom:4px;font-size:13px"
                            >
                                <span class="material-icons" style="font-size:16px;color:#888">person</span>
                                {{ u.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ===== SECTION 6: RIWAYAT APPROVAL (MILESTONE TIMELINE) ===== -->
                <div class="mt-6" v-if="data.approvals && data.approvals.length > 0">
                    <p class="section-title">Riwayat Approval</p>
                    <div class="milestone-timeline">
                        <div
                            v-for="(a, ai) in data.approvals"
                            :key="'ap-'+ai"
                            class="milestone-item"
                        >
                            <div
                                class="milestone-icon"
                                :class="a.action === 'setuju' ? 'milestone-icon--approve' : 'milestone-icon--reject'"
                            >
                                <span class="material-icons" style="font-size:16px">
                                    {{ a.action === 'setuju' ? 'check' : 'close' }}
                                </span>
                            </div>
                            <div
                                class="milestone-content"
                                :class="a.action === 'setuju' ? 'milestone-content--approve' : 'milestone-content--reject'"
                            >
                                <div class="milestone-step-label">Langkah {{ ai + 1 }}</div>
                                <div class="milestone-approver-name">{{ a.approver_name }}</div>
                                <div class="milestone-meta">
                                    <span
                                        class="status-badge"
                                        :style="a.action === 'setuju'
                                            ? 'background:#DCFCE7;color:#166534;padding:2px 10px;font-size:11px'
                                            : 'background:#FEE2E2;color:#991B1B;padding:2px 10px;font-size:11px'"
                                    >{{ a.action === 'setuju' ? 'Disetujui' : 'Ditolak' }}</span>
                                    <span class="milestone-date">
                                        <span class="material-icons" style="font-size:12px">schedule</span>
                                        {{ a.created_at }}
                                    </span>
                                </div>
                                <div v-if="a.keterangan" class="milestone-note">
                                    "{{ a.keterangan }}"
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ===== SECTION 6.5: NEGOSIASI ANTAR HEAD ===== -->
                <div class="mt-6">
                    <p class="section-title" style="border-bottom-color:#fbbf24">
                        <span style="display:inline-flex;align-items:center;gap:6px">
                            <span class="material-icons" style="font-size:16px;color:#f59e0b;vertical-align:middle">forum</span>
                            Negosiasi Antar Head
                        </span>
                    </p>

                    <div
                        v-if="!data.negosiasiList || data.negosiasiList.length === 0"
                        style="color:#aaa;font-size:13px;padding:6px 0"
                    >
                        Belum ada komentar negosiasi.
                    </div>

                    <div
                        v-for="(n, ni) in data.negosiasiList"
                        :key="'nego-'+ni"
                        class="nego-row"
                        :class="{ self: n.is_self }"
                    >
                        <div class="nego-avatar" :style="n.is_self ? 'background:#16a34a' : 'background:#2563eb'">
                            {{ n.nama.charAt(0) }}
                        </div>
                        <div class="nego-bubble" :class="{ self: n.is_self }">
                            <div style="display:flex;align-items:center;gap:8px;margin-bottom:5px;flex-wrap:wrap">
                                <span style="font-weight:700;font-size:12px">{{ n.nama }}</span>
                                <span style="font-size:11px;color:#888;background:#e5e7eb;border-radius:4px;padding:0 6px">{{ n.jabatan }}</span>
                                <span style="font-size:11px;color:#aaa;margin-left:auto">{{ n.created_at }}</span>
                            </div>
                            <div style="font-size:13px;color:#333;white-space:pre-line">{{ n.komentar }}</div>
                        </div>
                    </div>

                    
                </div>


            </vs-card>
        </div>

        <!-- ===== DIALOG KONFIRMASI TOLAK ===== -->
        <vs-prompt
            @accept="submitApproval('tolak')"
            :active.sync="showConfirmTolak"
            title="Konfirmasi Penolakan"
            accept-text="Ya, Tolak"
            cancel-text="Batal"
            color="danger"
        >
            <div class="con-exemple-prompt">
                <p>Apakah Anda yakin ingin <b>menolak</b> SPPMTDOI ini?</p>
                <p v-if="form.keterangan" class="mt-2" style="font-size:12px;color:#555">
                    Keterangan: <i>{{ form.keterangan }}</i>
                </p>
                <vs-alert v-if="!form.keterangan" color="warning" class="mt-3">
                    Disarankan mengisi keterangan sebelum menolak.
                </vs-alert>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            isSubmitting: false,
            showConfirmTolak: false,
            data: {
                id: 1,
                nomor_pesanan: 'SP/SG/2025/001',
                pks: 'SEI GARO',
                obyek: 'PENGADAAN DAN PEMBUATAN BARU LORI REBUSAN 2,5 TON 10 (SEPULUH) UNIT',
                tanggal_pesan: '2025-09-20',
                ekspektasi_selesai: '2025-11-30',
                selesai_paling_lambat: '2025-12-07',
                nama_regional_head: 'Ahmad Gusmar Harahap',
                email_regional_head: 'ahmadgusmar.harahap@ptpn4.co.id',
                status: 'menunggu_rh2',
                catatan: 'Pengadaan ini merupakan penggantian lori rebusan yang sudah tidak layak pakai. Kondisi lori lama sudah berkarat dan beberapa unit mengalami kerusakan pada as roda. Diharapkan pengadaan dapat diselesaikan sebelum musim panen raya.',
                details: [
                    {
                        line_id: 1,
                        product_name: 'Lori Rebusan 2,5 Ton',
                        keterangan: 'Penggantian unit lama yang rusak',
                        jumlah: 10,
                        satuan: 'UNIT',
                        harga_pmt: 185000000,
                        harga_diinginkan: 175000000,
                        harga_jual: 180000000,
                        sub_materials: [
                            { nama: 'Besi Hollow 40x40', keterangan: 'Rangka utama lori', jumlah: 120, satuan: 'BATANG', harga_pmt: 85000, harga_diinginkan: 80000, harga_jual: 82000 },
                            { nama: 'Roda Lori (set 4)', keterangan: '4 roda per unit', jumlah: 40, satuan: 'SET', harga_pmt: 450000, harga_diinginkan: 420000, harga_jual: 435000 },
                            { nama: 'Plat Baja 6mm', keterangan: 'Alas wadah lori', jumlah: 20, satuan: 'LEMBAR', harga_pmt: 320000, harga_diinginkan: 300000, harga_jual: 310000 },
                            { nama: 'Cat Anti Karat', keterangan: 'Lapisan pelindung', jumlah: 10, satuan: 'KALENG', harga_pmt: 75000, harga_diinginkan: 70000, harga_jual: 72000 },
                        ],
                    },
                    {
                        line_id: 2,
                        product_name: 'As Roda Lori',
                        keterangan: 'Suku cadang tambahan',
                        jumlah: 20,
                        satuan: 'PCS',
                        harga_pmt: 4500000,
                        harga_diinginkan: 4000000,
                        harga_jual: 4200000,
                        sub_materials: [
                            { nama: 'Besi As ST60 Ø50mm', keterangan: 'Batang as utama', jumlah: 20, satuan: 'BATANG', harga_pmt: 1800000, harga_diinginkan: 1600000, harga_jual: 1700000 },
                            { nama: 'Pasak (Key)', keterangan: 'Pengunci roda', jumlah: 40, satuan: 'PCS', harga_pmt: 25000, harga_diinginkan: 22000, harga_jual: 23000 },
                            { nama: 'Seal Karet', keterangan: 'Pelindung debu as', jumlah: 40, satuan: 'PCS', harga_pmt: 18000, harga_diinginkan: 16000, harga_jual: 17000 },
                        ],
                    },
                    {
                        line_id: 3,
                        product_name: 'Bantalan (Bearing) SKF',
                        keterangan: 'Ukuran 6310 2RS',
                        jumlah: 40,
                        satuan: 'PCS',
                        harga_pmt: 350000,
                        harga_diinginkan: 320000,
                        harga_jual: 335000,
                        sub_materials: [
                            { nama: 'Inner Ring', keterangan: 'Cincin dalam bearing', jumlah: 40, satuan: 'PCS', harga_pmt: 120000, harga_diinginkan: 110000, harga_jual: 115000 },
                            { nama: 'Outer Ring', keterangan: 'Cincin luar bearing', jumlah: 40, satuan: 'PCS', harga_pmt: 130000, harga_diinginkan: 118000, harga_jual: 124000 },
                            { nama: 'Steel Ball', keterangan: 'Bola baja dalam bearing', jumlah: 40, satuan: 'SET', harga_pmt: 60000, harga_diinginkan: 55000, harga_jual: 57000 },
                            { nama: 'Grease Pelumas', keterangan: 'Pelumas anti-karat', jumlah: 40, satuan: 'PCS', harga_pmt: 15000, harga_diinginkan: 13000, harga_jual: 14000 },
                        ],
                    },
                ],
                lampiran2: [],
                lampiran: [
                    { jenis: 'gambar', jenis_label: 'Anggaran', nama: 'Justifikasi_Teknis_Pengadaan.docx' },
                    { jenis: 'dokumen', jenis_label: 'Lainnya', nama: 'dokumen_pendukung2.jpg' },
                ],
                tembusan2: [
                    { value: 'gambar', label: '2AKN' },
                    { value: 'dokumen', label: '3KGO' },
                    { value: 'dokumen2', label: 'Pertinggal' },
                ],
                tembusan: [
                    { id: 1, name: 'email1@ptpn4.co.id' },
                    { id: 2, name: 'email2@ptpn4.co.id' },
                    { id: 3, name: 'email3@ptpn4.co.id' },
                ],
                approvals: [
                    {
                        approver_name: 'Eko Prasetyo, ST (Regional Head)',
                        action: 'setuju',
                        keterangan: 'Sesuai kebutuhan lapangan dan sudah diverifikasi kondisi fisik lori.',
                        created_at: '2025-09-21 09:30',
                    },
                    {
                        approver_name: 'Eko Prasetyo, ST (Regional Head)',
                        action: 'setuju',
                        keterangan: 'Sesuai kebutuhan lapangan dan sudah diverifikasi kondisi fisik lori.',
                        created_at: '2025-09-22 10:10',
                    },
                ],
                negosiasiList: [
                    {
                        id: 1,
                        nama: 'Ahmad Gusmar Harahap',
                        jabatan: 'Regional Head PKS',
                        komentar: 'Harga yang diinginkan untuk Lori Rebusan terlalu jauh dari harga PMT. Apakah ada justifikasi teknis yang lebih detail mengenai selisih harga Rp 10 juta per unit?',
                        created_at: '2025-09-21 10:00',
                        is_self: false,
                    },
                    {
                        id: 2,
                        nama: 'Budi Santoso',
                        jabatan: 'Regional Head 2',
                        komentar: 'Harga tersebut sudah berdasarkan survei pasar terbaru yang kami riset. Dokumen survei sudah dilampirkan di bagian lampiran. Kondisi unit lama sudah sangat kritis dan mengganggu produksi.',
                        created_at: '2025-09-21 11:30',
                        is_self: true,
                    },
                    {
                        id: 3,
                        nama: 'Ahmad Gusmar Harahap',
                        jabatan: 'Regional Head PKS',
                        komentar: 'Sudah saya cek dokumen surveinya. Apakah bisa direvisi menjadi Rp 178.000.000/unit sebagai titik tengah? Saya akan proses approval jika harga bisa disesuaikan.',
                        created_at: '2025-09-22 08:45',
                        is_self: false,
                    },
                    {
                        id: 4,
                        nama: 'Budi Santoso',
                        jabatan: 'Regional Head 2',
                        komentar: 'Baik, saya akan diskusikan dengan tim teknis terlebih dahulu. Mohon ditunggu 1-2 hari kerja.',
                        created_at: '2025-09-22 09:15',
                        is_self: true,
                    },
                ],
            },
            form: {
                keterangan: '',
            },
            formNego: {
                komentar: '',
            },
            expandedRows: {},
            biayaTambahan: [
                { nama: 'Upah',       nilai: 0, icon: 'engineering',  iconColor: '#2563eb', iconStyle: 'background:#eff6ff' },
                { nama: 'Transport',  nilai: 0, icon: 'local_shipping', iconColor: '#16a34a', iconStyle: 'background:#f0fdf4' },
                { nama: 'Alat Berat', nilai: 0, icon: 'construction',  iconColor: '#d97706', iconStyle: 'background:#fffbeb' },
            ],
            isSubmittingNego: false,
            statusMap: {
                'menunggu_pks': { label: 'Menunggu Persetujuan Regional Head PKS', bg: '#FFF3CD', color: '#856404' },
                'menunggu_rh2': { label: 'Menunggu Persetujuan Regional Head 2',   bg: '#CCE5FF', color: '#004085' },
                'persiapan':    { label: 'Persiapan Produksi',                      bg: '#D4EDDA', color: '#155724' },
                'proses':       { label: 'Proses Produksi',                         bg: '#D1ECF1', color: '#0C5460' },
                'bast':         { label: 'BAST',                                    bg: '#E2D9F3', color: '#4A235A' },
            },
        }
    },
    computed: {
        totalJumlah() {
            if (!this.data.details) return 0
            return this.data.details.reduce((s, d) => s + (Number(d.jumlah) || 0), 0)
        },
        totalHargaPmt() {
            if (!this.data.details) return 0
            return this.data.details.reduce((s, d) => s + (Number(d.jumlah) * Number(d.harga_pmt) || 0), 0)
        },
        totalHargaDiinginkan() {
            if (!this.data.details) return 0
            return this.data.details.reduce((s, d) => s + (Number(d.jumlah) * Number(d.harga_diinginkan) || 0), 0)
        },
        totalHargaJual() {
            if (!this.data.details) return 0
            return this.data.details.reduce((s, d) => s + (Number(d.jumlah) * Number(d.harga_jual) || 0), 0)
        },
        totalBiayaTambahan() {
            return this.biayaTambahan.reduce((s, b) => s + (Number(b.nilai) || 0), 0)
        },
    },
    watch: {
        isLoading(val) {
            if (val) this.$vs.loading()
            else this.$vs.loading.close()
        },
    },
    methods: {
        toggleRow(i) {
            this.$set(this.expandedRows, i, !this.expandedRows[i])
        },
        hitungPersen(nilai) {
            if (!this.totalHargaJual || !nilai) return '0.00%'
            return ((Number(nilai) / this.totalHargaJual) * 100).toFixed(2) + '%'
        },
        back() {
            this.$router.push({ name: 'sppmtdoi' })
        },
        statusLabel(value) {
            return this.statusMap[value] ? this.statusMap[value].label : (value || '-')
        },
        statusStyle(value) {
            const s = this.statusMap[value]
            if (!s) return ''
            return `background:${s.bg};color:${s.color}`
        },
        formatRupiah(value) {
            if (!value && value !== 0) return '-'
            return 'Rp ' + Number(value).toLocaleString('id-ID')
        },
        downloadLampiran(file) {
            this.$vs.notify({
                color: 'primary',
                title: 'Unduh File',
                iconPack: 'feather',
                icon: 'icon-download',
                text: file.nama,
            })
        },
        addLampiran() {
            this.data.lampiran2.push({ jenis: 'dokumen', file: null, nama: '' })
        },
        removeLampiran(index) {
            this.data.lampiran2.splice(index, 1)
        },
        onFileChange(event, index) {
            const file = event.target.files[0]
            if (file) {
                this.data.lampiran2[index].file = file
                this.data.lampiran2[index].nama = file.name
            }
        },
        confirmTolak() {
            this.showConfirmTolak = true
        },
        submitNego() {
            if (!this.formNego.komentar.trim()) {
                this.$vs.notify({
                    color: 'warning',
                    title: 'Komentar Kosong',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    text: 'Tulis komentar sebelum mengirim',
                })
                return
            }
            this.isSubmittingNego = true
            setTimeout(() => {
                this.data.negosiasiList.push({
                    id: Date.now(),
                    nama: 'Budi Santoso',
                    jabatan: 'Regional Head 2',
                    komentar: this.formNego.komentar,
                    created_at: new Date().toLocaleString('id-ID', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }),
                    is_self: true,
                })
                this.formNego.komentar = ''
                this.isSubmittingNego = false
                this.$vs.notify({
                    color: 'success',
                    title: 'Komentar Terkirim',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    text: 'Komentar negosiasi berhasil dikirim',
                })
            }, 500)
        },
        submitApproval(action) {
            if (action === 'tolak' && !this.form.keterangan) {
                this.$vs.notify({
                    color: 'warning',
                    title: 'Keterangan Diperlukan',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    text: 'Isi keterangan sebelum menolak',
                })
                return
            }

            this.isSubmitting = true
            setTimeout(() => {
                this.isSubmitting = false
                this.$vs.notify({
                    color: action === 'setuju' ? 'success' : 'warning',
                    title: action === 'setuju' ? 'Berhasil Disetujui' : 'Ditolak',
                    iconPack: 'feather',
                    icon: action === 'setuju' ? 'icon-check' : 'icon-x',
                    text: action === 'setuju'
                        ? 'SPPMTDOI berhasil disetujui'
                        : 'SPPMTDOI telah ditolak',
                })
                this.$router.push({ name: 'sppmtdoi' })
            }, 800)
        },
    },
    mounted() {
        // fetchData() — aktifkan saat backend siap
    },
}
</script>